import React, { Component } from "react";
import { Panel, Row, Col } from "react-bootstrap";
import AscModal from "../Elements/Modal/Modal";
import InlineForm from "../Elements/FromGroup/InlineForm";
import "../Elements/FromGroup/form_select.css";
import CallType from "../Script/Template/CallType";

export default class IvrHistoryModal extends Component {
    getModalInfo = () => {
        let {
            state,
            langText,
            getScopeGreaterEqual,
            GlobalConst,
            getMomentTime,
            secToTime,
        } = this.props;

        let selected = state.selectedRow || {};
        let blocks = selected.blocks || [];

        return (
            <div>
                {/* 通話情報 */}
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>{langText.Body.IvrHistoryCallInfo}</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            {getScopeGreaterEqual && getScopeGreaterEqual(GlobalConst.SCOPE_OBJECT.oem) && (
                                <Col xs={12}>
                                    <InlineForm
                                        key="company_name"
                                        controlId="company_name"
                                        label={langText.Body.CompanyName}
                                    >
                                        <p className="form-control-static">{selected.company_name || "-"}</p>
                                    </InlineForm>
                                </Col>
                            )}
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="extension_number"
                                    controlId="extension_number"
                                    label={langText.Body.ExtensionNumber}
                                >
                                    <p className="form-control-static">{selected.extension_number || "-"}</p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="display_number"
                                    controlId="display_number"
                                    label={langText.Body.ExternalNumber}
                                >
                                    <p className="form-control-static">
                                        {selected.display_number
                                            ? (selected.external_number_memo && selected.external_number_memo.trim()
                                                ? selected.display_number + " (" + selected.external_number_memo + ")"
                                                : selected.display_number)
                                            : "-"}
                                    </p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="dest_tel_no"
                                    controlId="dest_tel_no"
                                    label={langText.Body.DestUserNumber}
                                >
                                    <p className="form-control-static">{selected.dest_tel_no || "-"}</p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="disposition"
                                    controlId="disposition"
                                    label={langText.Body.Result}
                                >
                                    <p className="form-control-static">{selected.disposition || "-"}</p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="start_datetime"
                                    controlId="start_datetime"
                                    label={langText.Body.StartTime}
                                >
                                    <p className="form-control-static">
                                        {selected.start_datetime
                                            ? getMomentTime({ date: selected.start_datetime, format: "YYYY/MM/DD HH:mm:ss" })
                                            : "-"}
                                    </p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="billsec"
                                    controlId="billsec"
                                    label={langText.Body.TalkingTime}
                                >
                                    <p className="form-control-static">
                                        {selected.billsec != null ? secToTime(selected.billsec) : "-"}
                                    </p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="ct60_id"
                                    controlId="ct60_id"
                                    label={langText.Body.CallHistoryId}
                                >
                                    <p className="form-control-static">{selected.ct60_id || "-"}</p>
                                </InlineForm>
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>

                {/* スクリプト情報 */}
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>{langText.Body.IvrHistoryScriptInfo}</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="script_name"
                                    controlId="script_name"
                                    label={langText.Body.ScriptName}
                                >
                                    <p className="form-control-static">{selected.script_name || "-"}</p>
                                </InlineForm>
                            </Col>
                            <Col xs={12} sm={6}>
                                <InlineForm
                                    key="version"
                                    controlId="version"
                                    label={langText.Body.CurrentVersion}
                                >
                                    <p className="form-control-static">
                                        {selected.version != null ? "ver." + selected.version : "-"}
                                    </p>
                                </InlineForm>
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>

                {/* ブロック通過一覧 */}
                <Panel bsStyle="info">
                    <Panel.Heading>
                        <Panel.Title>{langText.Body.IvrHistoryBlockPassList}</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body style={{ padding: 0 }}>
                        {blocks.length > 0 ? (
                            <table className="table table-bordered table-striped" style={{ marginBottom: 0, fontSize: "12px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: "50px", textAlign: "center" }}>{langText.Body.IvrHistoryBlockOrder}</th>
                                        <th>{langText.Body.IvrHistoryBlockTitle}</th>
                                        <th style={{ width: "80px" }}>{langText.Body.IvrHistoryBlockTypeLabel}</th>
                                        <th style={{ width: "120px" }}>{langText.Body.IvrHistoryBlockContent}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {blocks.map((block, idx) => (
                                        <tr key={idx}>
                                            <td style={{ textAlign: "center" }}>{idx + 1}</td>
                                            <td>{block.title || "-"}</td>
                                            <td>{this.props.getBlockTypeLabel(block.type)}</td>
                                            <td>
                                                {(() => {
                                                    let bType = Number(block.type);
                                                    let hasResult = block.result != null && block.result !== "" && block.result !== "null";
                                                    if (bType === CallType.QUESTION) {
                                                        return hasResult ? String(block.result) : langText.Body.IvrHistoryOther;
                                                    }
                                                    if (bType === CallType.NUMBER) {
                                                        return hasResult ? String(block.result) : langText.Body.IvrHistoryNoInput;
                                                    }
                                                    return hasResult ? String(block.result) : "-";
                                                })()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p style={{ padding: "10px 15px", marginBottom: 0, color: "#888" }}>
                                {langText.Table.NoDataText}
                            </p>
                        )}
                    </Panel.Body>
                </Panel>
            </div>
        );
    }

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                customBtn1Func={this.props.closeModal}
                customBtn1Msg={this.props.langText.Body.Close}
                customBtn1Class="close-execute"
            >
                {this.getModalInfo()}
            </AscModal>
        );
    }
}
